import React from 'react'
import {SvgIcon, SvgIconProps} from '@mui/material'

const TradeIconSvg = (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.682 18.5987H18.317V21L24 16.1174L18.317 11.1387V13.492H10.1046V16.1174L4.35752 11.1387L10.1046 6V8.41729H15.7556" stroke="currentColor" strokeWidth="0.75"
              strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)
const Trade: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {TradeIconSvg}
    </SvgIcon>
)
export default Trade
